import {
  FormControl,
  FormsModule,
  NgForm,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { Component, ChangeDetectionStrategy } from '@angular/core';

import { FormComponent } from '@classes/form';
import { AlertComponent } from '@components/alert/alert.component';

@Component({
  selector: 'app-contact',
  imports: [FormsModule, ReactiveFormsModule, AlertComponent],
  templateUrl: './contact.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './contact.scss',
})
export class Contact extends FormComponent {
  protected readonly contactEmail = 'arteyculturags@gmail.com';

  override form = this.formBuilder.group({
    email: new FormControl('', [Validators.required, Validators.email]),
    name: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {
    this.endpoint = 'api/contact';
    this.method = 'post';
  }

  override isValid(): boolean {
    this.form.markAllAsTouched();

    const valid = this.form.valid;

    if (!valid) {
      this.handleAlert('Por favor, complete todos los campos.', 'danger');
    }

    return valid;
  }

  override getParams() {
    return this.form.value;
  }

  override success(_response: any): void {
    this.handleAlert(
      'Gracias por su mensaje. Le responderemos a la brevedad.',
      'success',
    );

    this.form.reset();
    this.stopLoading();
  }
}
